(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.FeatureToggleService = {}));
})(this, (function (exports) { 'use strict';

    var _a;
    var version = '6.1.0';
    var settings = (_a = {}, _a[version] = {}, _a);
    /**
     * Checks if Feature toggle/flag exists and it's on.
     *
     * @param key - Feature toggle/flag key to be checked
     * @param debug - Prints configuration, version and settings for debug purposes
     *
     * @returns Boolean
     *
     */
    var isOn = function (key, debug) {
        if (!!debug) {
            // tslint:disable-next-line
            console.log("\n[DEBUG] Execution Time in milliseconds: ".concat(Date.now(), " version: \"").concat(version, "\" key: \"").concat(key, "\" settings: ").concat(JSON.stringify(settings), "\n"));
        }
        return typeof key === 'string' && !!settings[version][key];
    };
    /**
     * Set feature toggle/flag configuration
     *
     * @param obj - Configuration of your feature toggle/flag
     *
     * @returns void
     *
     */
    var set = function (obj) {
        settings[version] = Object.assign({}, settings[version], obj);
    };

    exports.isOn = isOn;
    exports.set = set;

}));
